import {openSystemHealthSection} from '../maintenanceTabs/adapter';

/**
 * Canvas Maintenance > System Health(Infra).
 *
 * A destination rather than a record collection: it shows the Canvas platform's own service and cluster health,
 * and nothing inside it is something the agent acts on yet. So it declares
 * `options` and `view` and no resolver, filter or modal - publishing
 * operations no handler backs is the disagreement the navigation inventory
 * exists to record.
 */
const systemHealthPlugin = {
	id: 'system_health',
	version: 1,
	commandVersion: 1,
	resource: 'system_health',
	operations: ['view'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.system_health': openSystemHealthSection,
	},
};

export default systemHealthPlugin;
